jQuery( document ).ready(function($) { 
  
  // SMOOTH SCROLL AND CORRECTED POSITION FOR UKK Table of contents LINKS //

  $(".question-link").click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top - 140},'slow');
});
  

});
